import React, { useState } from "react";
import WidgetSelector from "./WidgetSelector";
import { useNavigate } from 'react-router-dom';
import { Notifications } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { IconButton, InputBase, Paper, Typography } from "@mui/material";
import { Person } from "@mui/icons-material";
import Tour from "./TutorialTour";
import { useAuth0 } from "@auth0/auth0-react";
import EQLogo1 from '../Screens/EQUINOCT-192x192.png'
import NavBarDropdown from "./NavBarDropdown";



interface NavigationBarProps {
  activeControl: string;
  setActiveControl: (view: string) => void;
  setActiveView: (view: string) => void;
  menuItems: string[];
  activeView: string;
  widgetsVisible: boolean;
  setWidgetsVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const NavigationBar: React.FC<NavigationBarProps> = ({
  activeControl,
  setActiveControl,
  setActiveView,
  menuItems,
  activeView,
  widgetsVisible,
  setWidgetsVisible,
}) => {

  const navigate = useNavigate();
  //const [activeControl, setActiveControl] = useState('monitor');
  const { user, isAuthenticated, isLoading } = useAuth0();

  console.log("Navbar:", widgetsVisible);

  return (
    <header className="flex items-center justify-between bg-zinc-900 bg-opacity-90 py-2 px-4 w-full">
      <div className="flex gap-2 pl-0 items-center justify-start">
        <a href="https://www.equinoct.com/">
          <img src={EQLogo1} alt="Logo" className="logo" style={{ width: '45px', height: '45px', opacity: '100%', objectFit: 'contain', borderRadius: '50%' }} />
        </a>
        <div className="text-[#97C7D6] text-[32px] font-inter ">
          Seasight
        </div>
        <Typography sx={{ fontFamily: 'sarabun', color: '#fff', pt: '5px', opacity: '90%', textWrap: 'nowrap' }}> Tidal Dashboard </Typography>
      </div>

      <nav className="flex justify-center">
        <ul className="flex gap-7 items-center list-none mb-2 ml-7">
          {menuItems.map((item, index) => (
            <li key={index} className="relative">
              <Link
                to={`/${item.toLowerCase()}`}
                className={` text-white no-underline font-inter bg-transparent w-full block text-center relative z-10 ${activeControl.toLowerCase() === item.toLowerCase() ? "font-semibold text-[17px]" : "text-base"}`}
                onClick={() => {
                  setActiveControl(item);
                  // setActiveView('visualization');
                }}
              >
                {item}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div className="flex pr-8 gap-3 items-center justify-end">
        <div className="widget-selector-container" style={{ width: 100 }}>
          {activeControl.toLowerCase() === "map" && (
            <WidgetSelector
              widgetsVisible={widgetsVisible}
              setWidgetsVisible={setWidgetsVisible}
            />
          )}
        </div>
        {/* Take a tour */}
        {/* <div className="widget-selector-container" style={{ width: 110 }}>
          <Tour />
        </div> */}
        {/* <LocationSelector /> */}
        <IconButton
          aria-label={'user'}
          // size="large"
          sx={{
            width: '35px',
            height: '35px',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            border: '0.5px solid rgba(97, 179, 255, 0.5)',
            color: '#61B3FF',
            borderRadius: '50%',
            padding: '10px',
          }}
        >
          <Notifications sx={{ color: '#fff', height: '25px' }} />
        </IconButton>
        <NavBarDropdown />
      </div>
    </header>
  );
};

export default NavigationBar;
